import React from 'react';
import { MdPolicy, MdListAlt } from 'react-icons/md';
import { FaBed } from 'react-icons/fa';
import { Card, Tabs } from 'components/common';
import ExpensePolicyGrid from 'components/app/bookings/travel/setting/expense/component/ExpensePolicyGrid';
import {
  getAllExpenses,
  getStaffPolicySalesExpenses,
  getStaffPolicyCMDExpenses,
  getHotelExpenses,
} from 'redux/booking/travel/setting/expenseSlice';

const ExpensePolicyPage = () => {
  const tabs = [
    { label: 'All', icon: <MdListAlt size={14} />, content: <ExpensePolicyGrid stateKey="allData" loadThunk={getAllExpenses} exportType="all" /> },
    { label: 'Staff policy by Sales', icon: <MdPolicy size={14} />, content: <ExpensePolicyGrid stateKey="staffPolicySalesData" loadThunk={getStaffPolicySalesExpenses} exportType="staff_policy_sales" /> },
    { label: 'Staff policy by CMD', icon: <MdPolicy size={14} />, content: <ExpensePolicyGrid stateKey="staffPolicyCMDData" loadThunk={getStaffPolicyCMDExpenses} exportType="staff_policy_cmd" /> },
    { label: 'Hotel', icon: <FaBed size={14} />, content: <ExpensePolicyGrid stateKey="hotelData" loadThunk={getHotelExpenses} exportType="all" /> },
  ];

  return (
    <div className="tw-flex tw-flex-col tw-gap-3 tw-p-4">
      <div className="tw-flex tw-items-center tw-gap-3">
        <div className="tw-w-1.5 tw-h-10 tw-rounded-sm tw-flex-shrink-0" style={{ background: 'linear-gradient(to bottom, #0ea5e9, #6366f1)' }} />
        <div className="tw-flex tw-items-center tw-gap-2">
          <MdPolicy className="tw-text-blue-600" size={22} />
          <div>
            <h1 className="tw-mb-0 tw-font-bold tw-text-2xl tw-text-gray-900">Travel Expense Policy</h1>
            <p className="tw-text-gray-500 tw-text-sm tw-mb-0">Define per-diem and expense rules by area, staff policy and country scope.</p>
          </div>
        </div>
      </div>

      <Card padding="none">
        <Tabs
          variant="underline"
          lazyMount
          navClassName="tw-px-3 tw-pt-2 tw-bg-white"
          contentClassName="tw-bg-slate-50 tw-p-4"
          tabs={tabs}
        />
      </Card>
    </div>
  );
};

export default ExpensePolicyPage;
